import type { Filters } from "../api/types";
import type { FilterForm } from "./types";

export const YEAR_MIN = 1935;
export const YEAR_MAX = Math.max(new Date().getFullYear(), 2026);
export const RATING_OPTIONS = [5, 6, 7, 8, 9] as const;

export function defaultFilterForm(): FilterForm {
  return { countries: [], genres: [], ratingFrom: 5, yearFrom: 1980, yearTo: YEAR_MAX };
}

export function toggleValue(list: readonly string[], value: string): string[] {
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
}

/** Двигаем один ползунок; второй подтягивается, чтобы «от» не стало больше «до». */
export function setYear(form: FilterForm, which: "from" | "to", raw: number): FilterForm {
  const value = Math.min(YEAR_MAX, Math.max(YEAR_MIN, Math.round(raw)));
  return which === "from"
    ? { ...form, yearFrom: value, yearTo: Math.max(form.yearTo, value) }
    : { ...form, yearTo: value, yearFrom: Math.min(form.yearFrom, value) };
}

export function formToFilters(form: FilterForm): Filters {
  return {
    countries: form.countries,
    genres: form.genres,
    rating_from: form.ratingFrom,
    year_from: form.yearFrom,
    year_to: form.yearTo,
  };
}
